<template>
    <div class="col m-3" v-if="message">
        <div class="msg-wrapper d-flex justify-content-start" :class="incoming ? 'incoming' : 'outgoing'">
            <div class="msg-image" v-if="message.creator && !incoming">
                <div class="circular" v-bind:style="{ backgroundImage: `url(${message.creator.image})` }"></div>
            </div>
            <div class="msg-content-wrapper">
                <div class="msg-content">
                    {{ message.content }}
                </div>
                <small class="msg-date mt-1">
                    {{ $date(message.created_at).format('HH:mm | DD-MM-YYYY') }}
                </small>
            </div>
            <div class="msg-image" v-if="message.creator && incoming">
                <div class="circular" v-bind:style="{ backgroundImage: `url(${message.creator.image})` }"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'message-wrapper',
    props: {
        message: {
            type: Object,
            required: true
        },
        incoming: {
            type: Boolean,
            default: false
        }
    }
}
</script>
